<script lang="ts">
	import type { CartState } from '../../handlers/cart_state.svelte';
	import type { sellers } from '$lib/tools/graphdb';

	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';
	import Image from '$lib/utils/components/Image.svelte';

	let { cart_state, sellers_list }: { cart_state: CartState; sellers_list: { values: sellers[] } } = $props();

	async function on_seller_select(seller: sellers) {
		if (!seller) return;
		cart_state.variables.seller = seller;
	}
</script>

<div dir="rtl" class="w-full space-y-6 py-6 pb-24">
	<h3 class="text-lg font-bold text-center mb-6">Select a Store</h3>

	<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
		{#each sellers_list.values as seller}
			<button
				class="group relative flex items-center gap-4 p-4 rounded-xl border border-border bg-card hover:bg-accent/50 hover:border-primary/50 text-start transition-all duration-200 shadow-sm hover:shadow-md"
				onclick={() => on_seller_select(seller)}
			>
				<div
					class="h-12 w-12 rounded-lg bg-muted flex items-center justify-center overflow-hidden border shadow-sm group-hover:scale-105 transition-transform"
				>
					<Image
						image_id={seller.image_id}
						width="48"
						height="48"
						fallback_icon={{ source: 'lucide', name: 'Store' }}
					/>
				</div>
				<div class="flex-1 min-w-0">
					<span class="font-bold text-sm block truncate group-hover:text-primary transition-colors">{seller.name}</span>
					<span class="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
						<LucideIcon name="ChevronLeft" size="12" />
						Select Store
					</span>
				</div>
			</button>
		{/each}
	</div>
</div>
